export default __webpack_public_path__ + "static/media/competition-play.2a3f73ba.png";